/*** Modal Overlay ***/
function showModal(contentId) {

  /* display the correct modal content */
  document.getElementById('modalContent1').style.display = "none";
  document.getElementById('modalContent2').style.display = "none";
  document.getElementById('modalContent3').style.display = "none";
  document.getElementById('modalContent4').style.display = "none";
  document.getElementById(contentId).style.display = "block";

  /* Add class to the html tag */
  document.documentElement.classList.add('modalDisplayed');
  document.getElementsByClassName("modal")[0].classList.remove("modalOut");
  document.getElementsByClassName("modal")[0].classList.add("modalIn");
}

/* Hides the modal overlay */
function hideModal() {
  /* remove class from the html tag */
  document.documentElement.classList.remove('modalDisplayed');
  document.getElementsByClassName("modal")[0].classList.remove("modalIn");
  document.getElementsByClassName("modal")[0].classList.add("modalOut");
}
/***END Modal Overlay ***/

/*** SMPTE Timecode counter ***/
var trackingMethodsCycleInterval;


window.onload = function() {

  /* counts up from the time the page was loaded */
  if(this.document.getElementById('countup1')) {
    /* Sets the starting time */
    countUpFromTime(new Date().getTime(), 'countup1');
  }

  /* Cycles the Active/Passive images displayed */
  if(this.document.getElementById('trackingMethods')) {
    this.startTrackingMethodCycle(0);
  }

  /* Event listener for the modal window */
  if(this.document.getElementById('modalTrigger')) {

    /* Reference modal trigger */
    var modalTrigger = document.getElementById("modalTrigger");

    /* Reference modal */
    var latestModal = document.getElementById('motiveNewsModal');

    /* Display modal when triggered */
    modalTrigger.addEventListener("click", (e) => {
      e.preventDefault();

      /* Prevents double scrollbars when modal is displayed */
      document.documentElement.style.overflow = 'hidden';

      latestModal.open();

      //add hash to url
      window.location.hash='latest';
    });


    /* Triggers when the modal is closed */
    latestModal.addEventListener("modalClose", () => {

      /* Prevents double scrollbars when modal is displayed */
      document.documentElement.style.overflow = 'visible';

      //removes the hash from the url
      history.replaceState({}, document.title, ".");
    });

    /* Check if modal should be opened because hash is in url */
    if(window.location.hash) {

        //Puts hash in variable, and removes the # character
        var hash = window.location.hash.substring(1);
        if(hash == 'latest') {
          /* Prevents double scrollbars when modal is displayed */
          document.documentElement.style.overflow = 'hidden';

          latestModal.open();
        }

    }
  }

};

/* Displays the time from the starting time */
function countUpFromTime(countFrom, id) {
var now = new Date(),
    countFrom = new Date(countFrom),
    timeDifference = (now - countFrom); /* difference between now and when page was first loaded */

var secondsInADay = 60 * 60 * 1000 * 24,
    secondsInAHour = 60 * 60 * 1000;

days = Math.floor(timeDifference / (secondsInADay) * 1);
hours = Math.floor((timeDifference % (secondsInADay)) / (secondsInAHour) * 1);
mins = Math.floor(((timeDifference % (secondsInADay)) % (secondsInAHour)) / (60 * 1000) * 1);
secs = Math.floor((((timeDifference % (secondsInADay)) % (secondsInAHour)) % (60 * 1000)) / 1000 * 1);
milli = timeDifference;

/* Parent DOM element */
var idEl = document.getElementById(id);

idEl.getElementsByClassName('hours')[0].innerHTML = ('0' + hours).slice(-2);
idEl.getElementsByClassName('minutes')[0].innerHTML = ('0' + mins).slice(-2);
idEl.getElementsByClassName('seconds')[0].innerHTML = ('0' + secs).slice(-2);
idEl.getElementsByClassName('milliseconds')[0].innerHTML = milli.toString().slice(-3,-1);

clearTimeout(countUpFromTime.interval);
countUpFromTime.interval = setTimeout(function(){ countUpFromTime(countFrom, id); }, 10);
}
/*** END SMPTE Timecode counter ***/

/*** Active Passive Image Cycle ***/
function startTrackingMethodCycle(secondsToDelay) {
clearInterval(trackingMethodsCycleInterval);
/* Delays before starting cycle */
setTimeout(function(){
  /* Cycle every 3 seconds */
  clearInterval(trackingMethodsCycleInterval);
  trackingMethodsCycleInterval = setInterval(trackingMethodsCycle, 3000);
}, secondsToDelay * 1000)

}
function trackingMethodsCycle() {
var trackingParent = this.document.getElementById('trackingMethods');
if(trackingParent.classList.contains('passiveDisplayed')) {
  trackingParent.classList.remove('passiveDisplayed');
  trackingParent.classList.add('activeDisplayed');
} else {
  trackingParent.classList.remove('activeDisplayed');
  trackingParent.classList.add('passiveDisplayed');
}
}

function trackingMethodDisplay(method) {
var trackingParent = this.document.getElementById('trackingMethods');
clearInterval(trackingMethodsCycleInterval);
if(method=='active') {
  trackingParent.classList.remove('passiveDisplayed');
  trackingParent.classList.add('activeDisplayed');
} else {
  trackingParent.classList.remove('activeDisplayed');
  trackingParent.classList.add('passiveDisplayed');
}
}
/*** END Active Passive Image Cycle ***/

/*** Setup and Operation aim assist ***/
function aimAssistToggle() {
var trackingParent = this.document.getElementById('setupOpVisual');
if(trackingParent.classList.contains('screen1Displayed')) {
  trackingParent.classList.remove('screen1Displayed');
  trackingParent.classList.add('screen2Displayed');
} else {
  trackingParent.classList.remove('screen2Displayed');
  trackingParent.classList.add('screen1Displayed');
}
}
/*** END Setup and Operation aim assist***/

/***  lightbox ***/
$(document).ready(function() {
if(window.document.getElementById('motive-indepth')) {
  $('.lightbox-video-inline').magnificPopup({type:'inline', removalDelay: 300, mainClass: 'mfp-fade', callbacks: {open: function(){

  }}});
  $('.lightbox-image').magnificPopup({type:'image', removalDelay: 300, mainClass: 'mfp-fade'});
}
});

/* lightbox */
$(document).ready(function() {
  $('.lightbox-video').magnificPopup({type:'iframe', zoom: {enabled: true, duration: 300, easing: 'ease-in-out'}, removalDelay: 300, mainClass: 'mfp-fade'});
});
/*** END lightbox ***/

/*** Solver Video Toggle ***/
if(window.document.getElementById('motive-indepth')) {
  var toggleBtns = document.querySelectorAll("#toggleButtons button");
  var currentVideo = document.getElementById("solverMarkersVid");
  var cycleSolverInterval;
  var markersTimeout;
  var skeletonsTimeout;
  var modelsTimeout;
  toggleBtns.forEach((button) => {
    button.addEventListener("click", toggleSolverVideo);

  });

  //stops the auto cycle when mouse is near the buttons
  document.getElementById("toggleButtons").addEventListener("mouseover", stopAutoCycle);

  //restarts the auto cycle when mouse leaves area near the buttons
  document.getElementById("toggleButtons").addEventListener("mouseout", startAutoCycle);

  //auto cycles the solver video
  startAutoCycle();
}

//auto cycles the solver video
function startAutoCycle() {
  stopAutoCycle();
  cycleSolverInterval = setInterval(cycleSolverVideo, 4000);
}

// stops the solver video auto cycle
function stopAutoCycle() {
  clearInterval(cycleSolverInterval);
  clearTimeout(markersTimeout);
  clearTimeout(skeletonsTimeout);
  clearTimeout(modelsTimeout);
}

//auto cycles the solver video
function cycleSolverVideo(){
  var btnToClick;
  if(currentVideo.id=='solverSkeletonsVid'){
    btnToClick = document.getElementById("solverModelsButton");
  }else if(currentVideo.id=='solverModelsVid'){
    btnToClick = document.getElementById("solverMarkersButton");
  }else if(currentVideo.id=='solverMarkersVid'){
    btnToClick = document.getElementById("solverSkeletonsButton");
  }
  btnToClick.click();

}

function toggleSolverVideo(event){

  //reference videos
  var markersVid = document.getElementById("solverMarkersVid");
  var markersVidWrapper = document.getElementById("markersVidWrapper");
  var skeletonsVid = document.getElementById("solverSkeletonsVid");
  var skeletonsVidWrapper = document.getElementById("skeletonsVidWrapper");
  var modelsVid = document.getElementById("solverModelsVid");
  var modelsVidWrapper = document.getElementById("modelsVidWrapper");
  var pauseDelay = 1500;

  // removes the selected class from all buttons
  toggleBtns.forEach((button) => {
    button.classList.remove('selected');
  });
  //adds the selected class to clicked button
  event.target.classList.add('selected');

  //determine the new video to display
  var videoToDisplay = event.target.dataset.videoType;
  //get the current time on the playing video
  var currentVideoTime = currentVideo.getTime();

  //Markers video
  if(videoToDisplay == 'Markers'){
    markersVidWrapper.style.opacity = 1;
    currentVideo = markersVid;
    markersVid.setTime(currentVideoTime);
    markersVid.play();
    skeletonsTimeout = setTimeout(function(){skeletonsVid.pause();},pauseDelay);
    modelsTimeout = setTimeout(function(){modelsVid.pause();},pauseDelay);
  }else{
    markersVidWrapper.style.opacity = 0;
  }

  //Skeletons video
  if(videoToDisplay == 'Skeletons'){
    skeletonsVidWrapper.style.opacity = 1;
    currentVideo = skeletonsVid;
    skeletonsVid.setTime(currentVideoTime);
    skeletonsVid.play();
    markersTimeout = setTimeout(function(){markersVid.pause();},pauseDelay);
    modelsTimeout = setTimeout(function(){modelsVid.pause();},pauseDelay);
  }else{
    skeletonsVidWrapper.style.opacity = 0;
  }

  //Models video
  if(videoToDisplay == 'Models'){
    modelsVidWrapper.style.opacity = 1;
    currentVideo = modelsVid;
    modelsVid.setTime(currentVideoTime);
    modelsVid.play();
    markersTimeout = setTimeout(function(){markersVid.pause();},pauseDelay);
    skeletonsTimeout = setTimeout(function(){skeletonsVid.pause();},pauseDelay);
  }else{
    modelsVidWrapper.style.opacity = 0;
  }

}

/*** END Solver Video Toggle ***/

  //Getting the elements to assign css custom properties
  const scrollTrackerElements = document.querySelectorAll('.scrollTracker');

  //Tracks the scroll position of elements and adds css custom properties to the element - used for animation
 window.addEventListener('scroll', () => {

   scrollTrackerElements.forEach(element => {
     let bounding = element.getBoundingClientRect();
     let viewportH = window.innerHeight;
     let eleH = bounding.height;
     let eleT = bounding.top;
     let eleB = bounding.bottom;
     let eleC = eleT + eleH / 2;
     //let percentFromViewport = Math.round(((viewportH - eleT) / eleH) * 100);
     let decimalInViewport = ((viewportH - eleT) / eleH);

     //only displays values between 0 and 1 - helpful for animation
     if(decimalInViewport > 1){
       decimalInViewport = 1;
     }else if(decimalInViewport < 0){
       decimalInViewport = 0;
     }

     //console.log('viewportH:'+viewportH);
     //console.log('eleH:'+eleH);
     //console.log('eleT:'+eleT);
     //console.log('eleB:'+eleB);
     //console.log('eleC:'+eleC);
     //console.log('decimalInViewport:'+decimalInViewport);

     //Set CSS custom properties
     //element.style.setProperty('--scrollT',eleT);
     //element.style.setProperty('--scrollB',eleB);
     element.style.setProperty('--decimalInViewport',decimalInViewport);

   });
 });

 //Fades between two cinepuck videos
 const switchCinepuckVideo = (triggerId) => {

  //Get the trigger element from passed Id
  let trigger = document.getElementById(triggerId);

  //cinepuck videos
  let accuracyVideo = document.getElementById('cinepuckAccuracyVideo');
  let trackingVideo = document.getElementById('cinepuckTrackingVideo');
  let ledsVideo = document.getElementById('cinepuckLedsVideo');

  //Add the 'selected' class
  if(!trigger.classList.contains('selected')){
    trigger.classList.add('selected');
  }

  if(trigger.id == 'cinepuckAccuracyTrigger'){

    //removing the 'selected' class from other triggers
    document.getElementById('cinepuckTrackingTrigger').classList.remove('selected');
    document.getElementById('cinepuckLEDsTrigger').classList.remove('selected');

    //setting video classes
    accuracyVideo.classList.remove('cinepuckVideoFadeOut');
    accuracyVideo.classList.add('cinepuckVideoFadeIn');
    trackingVideo.classList.add('cinepuckVideoFadeOut');
    ledsVideo.classList.add('cinepuckVideoFadeOut');

    //play video from start
    accuracyVideo.currentTime = 0;
    accuracyVideo.play();

    //set next video to play
    videoCycle(accuracyVideo);


  }else if(trigger.id == 'cinepuckTrackingTrigger'){

    //removing the 'selected' class from other triggers
    document.getElementById('cinepuckAccuracyTrigger').classList.remove('selected');
    document.getElementById('cinepuckLEDsTrigger').classList.remove('selected');

    //setting video classes
    trackingVideo.classList.remove('cinepuckVideoFadeOut');
    accuracyVideo.classList.add('cinepuckVideoFadeOut');
    trackingVideo.classList.add('cinepuckVideoFadeIn');
    ledsVideo.classList.add('cinepuckVideoFadeOut');

    //play video from start
    trackingVideo.currentTime = 0;
    trackingVideo.play();

    //set next video to play
    videoCycle(trackingVideo);

  }else if(trigger.id == 'cinepuckLEDsTrigger'){

    //removing the 'selected' class from other triggers
    document.getElementById('cinepuckAccuracyTrigger').classList.remove('selected');
    document.getElementById('cinepuckTrackingTrigger').classList.remove('selected');

    //setting video classes
    ledsVideo.classList.remove('cinepuckVideoFadeOut');
    accuracyVideo.classList.add('cinepuckVideoFadeOut');
    trackingVideo.classList.add('cinepuckVideoFadeOut');
    ledsVideo.classList.add('cinepuckVideoFadeIn');

    //play video from start
    ledsVideo.currentTime = 0;
    ledsVideo.play();

    //set next video to play
    videoCycle(ledsVideo);

  }else{
    return;
  }

 }

 //Trigger when the current video has finished playing
 const videoEndHandler = (event) => {
  //get the next trigger id from the element dataset
  let triggerId = event.target.dataset.nextTrigger;

  //switch to the next video
  switchCinepuckVideo(triggerId);
 }

//Cycles to the next video when the current video is finished
 const videoCycle = (videoElement) => {

  //cinepuck videos
  let accuracyVideo = document.getElementById('cinepuckAccuracyVideo');
  let trackingVideo = document.getElementById('cinepuckTrackingVideo');
  let ledsVideo = document.getElementById('cinepuckLedsVideo');

  //remove all previous event listeners
  if (accuracyVideo) {
    accuracyVideo.removeEventListener('ended', videoEndHandler, {once: true});
  }
  if (trackingVideo) {
    trackingVideo.removeEventListener('ended', videoEndHandler, {once: true});
  }
  if (ledsVideo) {
    ledsVideo.removeEventListener('ended', videoEndHandler, {once: true});
  }

  //set funciton to be called when video is finished playing
  if (videoElement) {
    videoElement.addEventListener('ended', videoEndHandler, {once: true});
  }
 }


//When one of the triggers are clicked
const cinepuckTriggerHandler = (event) =>{
  //prevent page reload
  event.preventDefault();

  //Get the id of the target to pass to the cycle function
  let triggerId = event.target.id;

  //Advance to the next video
  switchCinepuckVideo(triggerId);

 };

  //Get all triggers that will cycle the cinepuck videos
  const cinepuckTriggers = document.querySelectorAll("#cinepuckCycleTriggers a");

  //add event listener for each cinepuck trigger
  cinepuckTriggers.forEach((trigger) => {
    trigger.addEventListener('click', cinepuckTriggerHandler);
  });

    //go to next video when reaches end - for initial video
    videoCycle(document.getElementById('cinepuckAccuracyVideo'));

